import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

const releaseStage = document.querySelector('meta[name="environment"]')?.content || 'production'

Bugsnag.start({
    apiKey: 'b3ec68154b90832d01d171fb97a22d1e',
    releaseStage,
    plugins: [new BugsnagPluginVue()]
})

export const bugsnag = Bugsnag.getPlugin('vue')
export default Bugsnag
